import request from 'local_modules/request'
import { constants } from 'helpers'
import { reducers, getState } from 'redux/core'


const setFetching = (isFetching) => reducers.marketplace.adminGroupsAddPage.setFetching(isFetching)

const fetchGroups = () => {
  const { marketplace: { layersNavigation: { tool } } } = getState()

  return request.get(constants.marketplace.learn + `/${tool}`)
    .then(({ data }) => data)
    .then((data) => {
      const filteredGroups = data && data.length ? data.filter(({ active }) => active) : data

      reducers.marketplace.adminGroupsAddPage.setGroups(filteredGroups)

      return filteredGroups
    })
    .catch((error) => console.log(error))
}

const fetchGroupMembers = (groupId) => {
  return request.get(constants.marketplace.learnGroup + `/${groupId}/member?all=true`)
    .then(({ data }) => data)
    .then((data) => reducers.marketplace.adminGroupsAddPage.setGroupMembers({ groupId, members: data }))
    .catch((error) => console.log(error))
}

const setGroupMembers = ({ groupId, members }) => {
  return request.post(constants.marketplace.learnGroup + `/${groupId}/member?all=true`, members)
    .then(({ data }) => data)
    .catch((error) => console.log(error))
}

const updateGroupMember = ({ groupId, member }) => {
  return Number(member.id) === 0
    ? request.post(constants.marketplace.learnGroup + `/${groupId}/member`, member)
    : request.put(constants.marketplace.learnGroup + `/${groupId}/member`, member)
    .then(({ data }) => data)
    .catch((error) => console.log(error))
}

const toggleGroupMember = ({ groupId, member }) => {
  return request.put(constants.marketplace.learnGroup + `/${groupId}/member/${member.id}`, {})
    .then(({ data }) => data)
    .catch((error) => console.log(error))
}


export default {
  setFetching,
  fetchGroups,
  fetchGroupMembers,
  setGroupMembers,
  updateGroupMember,
  toggleGroupMember,
}
